import {
  LocationsAction,
  LocationsActionTypes,
  LocationsState
} from '../../types/locations';

const initialState: LocationsState = {
  locations: [],
  selectedLocations: [{ id: 0, name: 'All' }],
  loading: false
};

export const locationsReducer = (
  state = initialState,
  action: LocationsAction
): LocationsState => {
  switch (action.type) {
    case LocationsActionTypes.SET_LOCATIONS_LOADING: {
      return {
        ...state,
        loading: action.payload
      };
    }
    case LocationsActionTypes.GET_LOCATIONS: {
      return {
        ...state,
        locations: action.payload,
        loading: false
      };
    }
    case LocationsActionTypes.SET_SELECTED_LOCATIONS: {
      return {
        ...state,
        selectedLocations: action.payload
      };
    }
    default:
      return state;
  }
};
